import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { Link } from 'gatsby'
import React from "react";

const Feature = ({data, slug, lang}) => {

    const parts = slug.split("/");
    let partsURL = [];

    parts.shift();
    renderCrumbs();


    function convertPart(part) {
        const title = part.replace(/-/g,' ');
        return title;
    }

    function renderCrumbs(){
        let breadURL = '';

        parts.map((part) => {
            breadURL += `/${part}`;
            partsURL.push(breadURL)
        })
    }


    return (

    <div type={data.type} >

        { (data.featureType === 'Hero' && data.customClasses == 'feature-hero') &&
            <div className="features-hero">
                 <div className='breadcrumbs'>
                    <div className='crumb'><Link to='/'>Home </Link></div>
                    {
                        parts.map((crumb, i) =>
                            <div className='crumb'><Link to={partsURL[i]}>{convertPart(crumb)}</Link></div>
                        )
                    }
                </div>
                <div className="features-hero_wrapper">

                    <div className="content">
                        <div className="title"><h1>{data.subtitle}</h1></div>
                        <h2>{data.title}</h2>
                        {documentToReactComponents(JSON.parse(data.copy.raw))}
                        <div className="buttonRow">
                        { 
                            data?.buttons && data.buttons.map((buttons) =>
                                <Link to={buttons.destination} title={buttons.title} className={`button ${buttons.type}`}>{buttons.title}</Link>
                            )
                        }
                        </div>
                    </div>
                    <div className="image">
                        { data.graphic != null && <img src={data.graphic.file.url} alt={data.title} /> }
                    </div>
    
                </div>    
            </div>
        }


        { ((data.featureType === 'Centered' && data.title.includes('What Is')) ||  (data.featureType === 'Centered' && data.title.includes('What Are'))) &&
            <div className="row-container border-bottom">
                <div className="row-container_wrapper">
                    <h2>{data.title}</h2>
                    { data.copy != null && documentToReactComponents(JSON.parse(data.copy.raw)) }
                </div>
            </div>
        }


        { (data.featureType === 'Centered' && data.customClasses == 'dark-callout') &&
            <div className="belt-web-wrapper">
                <div className="belt">
                    <h2>Say goodbye to the pains of managing multiple file storage providers</h2>
                    <div className="buttonRows">
                        <div className="web-buttons webBtn">
                            <Link to="http://eepurl.com/hSb7QD" title="Chrome" className="web-btn" striphash><img src="/images/googleChrome.png" alt="" /></Link>
                            <Link to="http://eepurl.com/hSb7QD" title="Chrome" className="web-btn" striphash>Chrome</Link>
                        </div>
                        <div className="web-buttons webBtn">
                            <Link to="http://eepurl.com/hSb7QD" title="Web" className="web-btn" striphash><img src="/images/web.png" alt="" /></Link>
                            <Link to="http://eepurl.com/hSb7QD" title="Web" className="web-btn" striphash>Web</Link>
                        </div>
                        <div className="web-buttons">
                            <Link to="http://eepurl.com/hSb7QD" title="Edge" className="web-btn" striphash><img src="/images/microsoft.png" alt="" /></Link>
                            <Link to="http://eepurl.com/hSb7QD" title="Edge" className="web-btn" striphash>Edge</Link>
                        </div>
                    </div>
                    <p className='highlight'>Enjoy a better cloud storage experience with Drivey</p>
                </div>
            </div>
            // <div className="drivey-callout">
            //     <div className="drivey-callout_wrapper">
            //         <img src="/images/drivey-car.svg" alt="" />
            //         <h2>{data.title}</h2>
            //         { data.copy != null && documentToReactComponents(JSON.parse(data.copy.raw)) }
            //         <div className="buttonRow centered">
            //             { 
            //                 data?.buttons && data.buttons.map((buttons) =>
            //                     <Link to={buttons.destination} title={buttons.title} className={`button ${buttons.type}`}>{buttons.title}</Link>
            //                 )
            //             }
            //         </div>
            //     </div>
            // </div>
            
        }


        { (data.featureType === 'Centered' && data.title == 'Get started today and Drive Free') &&
            <div className="drivey-callout footer-cta">
                <div className="drivey-callout_wrapper">
                    <img src="/images/drivey-icon-with-cloud.png" alt="" />
                    <h2>{data.title}</h2>
                    <div className="buttonRow centered">
                        { 
                            data?.buttons && data.buttons.map((buttons) =>
                                <Link to={buttons.destination} title={buttons.title} className={`button ${buttons.type}`}>{buttons.title}</Link>
                            )
                        }
                    </div>
                </div>
            </div>
        }

    </div>
  );
};

export default Feature